import {
  DropdownMenuContent,
  DropdownMenuTrigger,
  Portal,
  DropdownMenu,
  DropdownMenuContentProps
} from '@radix-ui/react-dropdown-menu';
import { RadioGroup } from '@anyui/core';
import { Slot } from '@radix-ui/react-slot';
import { ReactNode } from 'react';
import { DropdownOption } from '@anytag/shared-types';
import { useToggleState } from '@anytag/shared-hooks';
import { cn } from '@anytag/shared-utils';
import { Radio } from '../Radio';
import { DropdownDefaultProps } from './types';

export interface DropdownSingleSelectMenuProps<T extends DropdownOption>
  extends DropdownDefaultProps<T>,
    DropdownMenuContentProps {
  selectedOption?: T;
  onSelectOption: (option: T) => void;
  trigger: ReactNode;
  withinPortal?: boolean;
}

export const DropdownSingleSelectMenu = <T extends DropdownOption>({
  options,
  selectedOption,
  onSelectOption,
  withinPortal,
  trigger,
  sideOffset = 4,
  align = 'end',
  side = 'bottom',
  className
}: DropdownSingleSelectMenuProps<T>) => {
  const MenuWrapper = withinPortal ? Portal : Slot;
  const { status, setStatus, close } = useToggleState();

  return (
    <DropdownMenu modal={false} open={status} onOpenChange={setStatus}>
      <DropdownMenuTrigger asChild>
        <MenuWrapper>{trigger}</MenuWrapper>
      </DropdownMenuTrigger>
      <MenuWrapper>
        <DropdownMenuContent
          className={cn(
            cn('z-10 box-border w-max max-w-87.5 min-w-41.25 rounded-sm bg-white p-2 menu-filter-shadow'),
            className
          )}
          sideOffset={sideOffset}
          align={align}
          side={side}
        >
          <RadioGroup
            direction="vertical"
            value={selectedOption?.value}
            onChange={(value) => {
              onSelectOption(options.find((o) => o.value === value) as T);
              close();
            }}
          >
            {options.map(({ gtmId, label, value, disabled, className }, index) => (
              <Radio
                id={gtmId}
                key={index}
                label={label}
                value={value}
                className={cn(
                  'mt-0! p-2.5 has-aria-checked:bg-zinc-100',
                  { 'hover:bg-zinc-100 hover:outline-none': !disabled },
                  className
                )}
              />
            ))}
          </RadioGroup>
        </DropdownMenuContent>
      </MenuWrapper>
    </DropdownMenu>
  );
};
